import { CoreIcon } from '../core-icon';
import addCircleFillSVG from '../../assets/icons/add-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const AddCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={addCircleFillSVG} {...props} />;
};
